enum MapLayerVisibility {
  VISIBLE = 'visible',
  NOT_VISIBLE = 'none',
}

export default MapLayerVisibility;
